// components/playground/sections/ActualDataView.jsx
import React from 'react';

const ActualDataView = ({ onCreateFirstScenario }) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div>
          <h3 className="text-lg font-bold text-blue-900 mb-2">
            Baseline Forecast
          </h3>
          <p className="text-blue-800 mb-4">
            This is your baseline view with real QuickBooks data and calculated projections.
            Create a new scenario to start planning with custom adjustments.
          </p>
          <button
            onClick={onCreateFirstScenario}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
          >
            + Create First Scenario
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActualDataView;